import { ConditionSheetsField } from '@src/permits/fields/Fields';
import {
  AxleCapacityField,
  AxleGroupField,
  AxleSpacingField,
  AxleTypeField,
  AxleWeightField,
  AxleWidthField,
  IsSteeringAxleField,
  SuspensionField,
  TireCountField,
  TireRatingField,
  TireSizeField,
} from '@src/permitTypesManager/permitTypeSections/AxleTireSuspensionFields';
import { CustomDocumentPdfFields } from '@src/permitTypesManager/permitTypeSections/CustomDocumentPdfFields';
import {
  AbMVIDNumberField,
  AccountNumbersBilingualField,
  BcCustomerNumberField,
  BcFINNumberField,
  CaNSCField,
  FederalIDNumberField,
  KentuckyNumberField,
  LaNumberField,
  MontanaNumberField,
  NLMasterNumberField,
  OnCVORNumberField,
  OnPRIOAccountNumberField,
  OregonNumberField,
  QcNEQNumberField,
  QcNIRNumberField,
  TennesseeNumberField,
  TexasNumberField,
  UsDotNumberField,
  UsICCField,
  UsIFTAField,
  UsIRPNumberField,
} from '@src/permitTypesManager/permitTypeSections/JurisdictionIdNumberFields';
import {
  IsUsedMobileHomeField,
  LoadIsMobileHomeField,
  MobileHomeBoxLengthField,
  MobileHomeBoxWidthField,
  MobileHomeCurbsideEavesLengthField,
  MobileHomeEaveWidthField,
  MobileHomeHitchLengthField,
  MobileHomeHudNumberField,
  MobileHomeMakeField,
  MobileHomeRoadsideEavesLengthField,
  MobileHomeSerialNumberField,
  MobileHomeYearField,
} from '@src/permitTypesManager/permitTypeSections/MobileHomeFields';
import {
  CurrencyField,
  HighPriorityField,
  JurisdictionField,
  JurisdictionUrlField,
  NameField,
  ShowToClientField,
  TypeField,
  UnitSystemFields,
  ValidateExpirationDateField,
  ValidateExpirationTimeField,
} from '@src/permitTypesManager/permitTypeSections/PermitDefinitionFields';
import { PermitInstructionsField } from '@src/permitTypesManager/permitTypeSections/PermitInstructionsField';
import {
  InsuranceAddressNumberField,
  InsuranceAgentField,
  InsuranceCompanyField,
  InsuranceCoverageAmountField,
  InsuranceEffectiveDateField,
  InsuranceExperienceDateField,
  InsuranceIsOnFileWithStateField,
  InsurancePhoneNumberField,
  InsurancePolicyNumberField,
} from '@src/permitTypesManager/permitTypeSections/PermitInsuranceFields';
import {
  CommodityField,
  EFFOverhangField,
  FrontOverhangField,
  LoadDescriptionField,
  LoadDispositionField,
  LoadEndToEndCount,
  LoadHeightField,
  LoadIndustryTypeField,
  LoadIsNewlyManufacturedField,
  LoadLengthField,
  LoadLoadingMethodField,
  LoadMakeField,
  LoadModelField,
  LoadOwnerAddressField,
  LoadOwnerNameField,
  LoadQuantityField,
  LoadSealedContainerChassisNumberField,
  LoadSealedContainerNumberField,
  LoadSerialNumberField,
  LoadSideBySideCount,
  LoadStackCountField,
  LoadWeightField,
  LoadWidthField,
  LoadYearField,
  OverallHeightField,
  OverallLengthField,
  OverallWeightField,
  OverallWidthField,
  RearOverhangField,
  SingleItemField,
} from '@src/permitTypesManager/permitTypeSections/PermitLoadFields';
import {
  FloridaTractorVehicleConfigurationField,
  OntarioTractorVehicleTypeField,
  OwnerAddressField,
  OwnerCityField,
  OwnerCompanyNameField,
  OwnerEmailField,
  OwnerPhoneField,
  OwnerStateField,
  OwnerZipCodeField,
  TractorAxleCountField,
  TractorBodyStyleField,
  TractorFuelTypeField,
  TractorHeightField,
  TractorIsLeasedField,
  TractorLengthField,
  TractorLicenseEffectiveDateField,
  TractorLicenseExpirationDateField,
  TractorLicenseIsApportionedPlateField,
  TractorLicensePlateNumberField,
  TractorLicensePlateStateField,
  TractorLicensePlateTypeField,
  TractorLicensePlateYearField,
  TractorMakeField,
  TractorModelNumberField,
  TractorOwnerNameField,
  TractorTypeField,
  TractorUnitNumberField,
  TractorUnladenWeightField,
  TractorVINField,
  TractorWheelBaseField,
  TractorWidthField,
  TractorYearField,
  USDOTNumberOfOwningCompanyField,
  VehicleOfSpecialDesignField,
} from '@src/permitTypesManager/permitTypeSections/PermitTractorFields';
import {
  IsDualLaneField,
  IsTrunnionAxleField,
  TrailerAxleCountField,
  TrailerDeckHeightField,
  TrailerEmptyWeightField,
  TrailerGroundClearanceField,
  TrailerHeightField,
  TrailerKingPinSetbackLengthField,
  TrailerKingPinSettingLengthField,
  TrailerLengthField,
  TrailerLicensePlateField,
  TrailerLicensePlateStateField,
  TrailerLicensePlateTypeField,
  TrailerMakeField,
  TrailerRegisteredWeightField,
  TrailerTypeField,
  TrailerUnitNumberField,
  TrailerVINField,
  TrailerWheelbaseField,
  TrailerWidthField,
  TrailerYearField,
} from '@src/permitTypesManager/permitTypeSections/TrailerFields';
import {
  TripBaseRegisteredWeightField,
  TripDestinationField,
  TripEffectiveDateField,
  TripFinalDestinationField,
  TripIncludesReturnTripField,
  TripMileageField,
  TripOriginalOriginField,
  TripOriginField,
  TripReturnDestinationField,
  TripReturnMileageField,
  TripReturnRouteField,
  TripRouteField,
} from '@src/permitTypesManager/permitTypeSections/TripInformationFields';
import * as yup from 'yup';

export const AddPermitTypeFormInputs = yup
  .object()
  .shape({
    [NameField.fieldName]: NameField.validator,
    [JurisdictionUrlField.fieldName]: JurisdictionUrlField.validator,
    [JurisdictionField.fieldName]: JurisdictionField.validator,
    [TypeField.fieldName]: TypeField.validator,
    [CurrencyField.fieldName]: CurrencyField.validator,
    [HighPriorityField.fieldName]: HighPriorityField.validator,
    [ShowToClientField.fieldName]: ShowToClientField.validator,
    [PermitInstructionsField.fieldName]: PermitInstructionsField.validator,
    [ValidateExpirationTimeField.fieldName]:
      ValidateExpirationTimeField.validator,
    [ValidateExpirationDateField.fieldName]:
      ValidateExpirationDateField.validator,
    [ConditionSheetsField.fieldName]: ConditionSheetsField.validator,

    [CustomDocumentPdfFields.fieldName]: CustomDocumentPdfFields.validator,
    [UnitSystemFields.fieldName]: UnitSystemFields.validator,
    [InsuranceCompanyField.fieldName]: InsuranceCompanyField.validator,
    [InsuranceEffectiveDateField.fieldName]:
      InsuranceEffectiveDateField.validator,
    [InsuranceExperienceDateField.fieldName]:
      InsuranceExperienceDateField.validator,
    [InsuranceCoverageAmountField.fieldName]:
      InsuranceCoverageAmountField.validator,
    [InsurancePolicyNumberField.fieldName]:
      InsurancePolicyNumberField.validator,
    [InsuranceAgentField.fieldName]: InsuranceAgentField.validator,
    [InsurancePhoneNumberField.fieldName]: InsurancePolicyNumberField.validator,
    [InsuranceAddressNumberField.fieldName]:
      InsuranceAddressNumberField.validator,
    [InsuranceIsOnFileWithStateField.fieldName]:
      InsuranceIsOnFileWithStateField.validator,
    [LoadModelField.fieldName]: LoadModelField.validator,
    [LoadMakeField.fieldName]: LoadMakeField.validator,
    [LoadQuantityField.fieldName]: LoadQuantityField.validator,
    [LoadYearField.fieldName]: LoadYearField.validator,
    [LoadDescriptionField.fieldName]: LoadDescriptionField.validator,
    [LoadLoadingMethodField.fieldName]: LoadLoadingMethodField.validator,
    [SingleItemField.fieldName]: SingleItemField.validator,
    [LoadSideBySideCount.fieldName]: LoadSideBySideCount.validator,
    [LoadEndToEndCount.fieldName]: LoadEndToEndCount.validator,
    [LoadStackCountField.fieldName]: LoadStackCountField.validator,
    [LoadDispositionField.fieldName]: LoadDispositionField.validator,
    [LoadIsNewlyManufacturedField.fieldName]:
      LoadIsNewlyManufacturedField.validator,
    [LoadIndustryTypeField.fieldName]: LoadIndustryTypeField.validator,
    [LoadSerialNumberField.fieldName]: LoadSerialNumberField.validator,
    [LoadOwnerNameField.fieldName]: LoadOwnerNameField.validator,
    [LoadOwnerAddressField.fieldName]: LoadOwnerAddressField.validator,
    [LoadWeightField.fieldName]: LoadWeightField.validator,
    [OverallWeightField.fieldName]: OverallWeightField.validator,
    [LoadWidthField.fieldName]: LoadWidthField.validator,
    [LoadHeightField.fieldName]: LoadHeightField.validator,
    [LoadLengthField.fieldName]: LoadLengthField.validator,
    [FrontOverhangField.fieldName]: FrontOverhangField.validator,
    [RearOverhangField.fieldName]: RearOverhangField.validator,
    [EFFOverhangField.fieldName]: EFFOverhangField.validator,
    [OverallLengthField.fieldName]: OverallLengthField.validator,
    [OverallHeightField.fieldName]: OverallHeightField.validator,
    [OverallWidthField.fieldName]: OverallWidthField.validator,
    [LoadSealedContainerNumberField.fieldName]:
      LoadSealedContainerNumberField.validator,
    [LoadSealedContainerChassisNumberField.fieldName]:
      LoadSealedContainerChassisNumberField.validator,
    [CommodityField.fieldName]: CommodityField.validator,
    [TractorUnitNumberField.fieldName]: TractorUnitNumberField.validator,
    [TractorYearField.fieldName]: TractorYearField.validator,
    [TractorMakeField.fieldName]: TractorMakeField.validator,
    [TractorTypeField.fieldName]: TractorTypeField.validator,
    [VehicleOfSpecialDesignField.fieldName]:
      VehicleOfSpecialDesignField.validator,
    [TractorBodyStyleField.fieldName]: TractorBodyStyleField.validator,
    [TractorModelNumberField.fieldName]: TractorModelNumberField.validator,
    [TractorVINField.fieldName]: TractorVINField.validator,
    [TractorFuelTypeField.fieldName]: TractorFuelTypeField.validator,
    [TractorAxleCountField.fieldName]: TractorAxleCountField.validator,
    [TractorLicensePlateNumberField.fieldName]:
      TractorLicensePlateNumberField.validator,
    [TractorLicensePlateStateField.fieldName]:
      TractorLicensePlateStateField.validator,
    [TractorLicenseEffectiveDateField.fieldName]:
      TractorLicenseEffectiveDateField.validator,
    [TractorLicenseExpirationDateField.fieldName]:
      TractorLicenseExpirationDateField.validator,
    [TractorLicensePlateTypeField.fieldName]:
      TractorLicensePlateTypeField.validator,
    [TractorLicenseIsApportionedPlateField.fieldName]:
      TractorLicenseIsApportionedPlateField.validator,
    [TractorLicensePlateYearField.fieldName]:
      TractorLicensePlateYearField.validator,
    [TractorIsLeasedField.fieldName]: TractorIsLeasedField.validator,
    [TractorOwnerNameField.fieldName]: TractorOwnerNameField.validator,
    [OwnerCompanyNameField.fieldName]: OwnerCompanyNameField.validator,
    [USDOTNumberOfOwningCompanyField.fieldName]:
      USDOTNumberOfOwningCompanyField.validator,
    [OwnerAddressField.fieldName]: OwnerAddressField.validator,
    [OwnerCityField.fieldName]: OwnerCityField.validator,
    [OwnerStateField.fieldName]: OwnerStateField.validator,
    [OwnerZipCodeField.fieldName]: OwnerZipCodeField.validator,
    [OwnerPhoneField.fieldName]: OwnerPhoneField.validator,
    [OwnerEmailField.fieldName]: OwnerEmailField.validator,
    [TractorHeightField.fieldName]: TractorHeightField.validator,
    [TractorWidthField.fieldName]: TractorWidthField.validator,
    [TractorLengthField.fieldName]: TractorLengthField.validator,
    [TrailerGroundClearanceField.fieldName]:
      TrailerGroundClearanceField.validator,
    [TractorWheelBaseField.fieldName]: TractorWheelBaseField.validator,
    [TractorUnladenWeightField.fieldName]: TractorUnladenWeightField.validator,
    [FloridaTractorVehicleConfigurationField.fieldName]:
      FloridaTractorVehicleConfigurationField.validator,
    [OntarioTractorVehicleTypeField.fieldName]:
      OntarioTractorVehicleTypeField.validator,
    [TrailerUnitNumberField.fieldName]: TrailerUnitNumberField.validator,
    [TrailerMakeField.fieldName]: TrailerMakeField.validator,
    [TrailerTypeField.fieldName]: TrailerTypeField.validator,
    [TrailerVINField.fieldName]: TrailerVINField.validator,
    [TrailerYearField.fieldName]: TrailerYearField.validator,
    [TrailerAxleCountField.fieldName]: TrailerAxleCountField.validator,
    [IsDualLaneField.fieldName]: IsDualLaneField.validator,
    [IsTrunnionAxleField.fieldName]: IsTrunnionAxleField.validator,
    [TrailerLicensePlateField.fieldName]: TrailerLicensePlateField.validator,
    [TrailerLicensePlateStateField.fieldName]:
      TrailerLicensePlateStateField.validator,
    [TrailerLicensePlateTypeField.fieldName]:
      TrailerLicensePlateTypeField.validator,
    [TrailerLengthField.fieldName]: TrailerLengthField.validator,
    [TrailerWidthField.fieldName]: TrailerWidthField.validator,
    [TrailerHeightField.fieldName]: TrailerHeightField.validator,
    [TrailerDeckHeightField.fieldName]: TrailerDeckHeightField.validator,
    [TrailerGroundClearanceField.fieldName]:
      TrailerGroundClearanceField.validator,
    [TrailerEmptyWeightField.fieldName]: TrailerEmptyWeightField.validator,
    [TrailerRegisteredWeightField.fieldName]:
      TrailerRegisteredWeightField.validator,
    [TrailerKingPinSetbackLengthField.fieldName]:
      TrailerKingPinSetbackLengthField.validator,
    [TrailerKingPinSettingLengthField.fieldName]:
      TrailerKingPinSettingLengthField.validator,
    [TrailerWheelbaseField.fieldName]: TrailerWheelbaseField.validator,
    [LoadIsMobileHomeField.fieldName]: LoadIsMobileHomeField.validator,
    [IsUsedMobileHomeField.fieldName]: IsUsedMobileHomeField.validator,
    [MobileHomeYearField.fieldName]: MobileHomeYearField.validator,
    [MobileHomeMakeField.fieldName]: MobileHomeMakeField.validator,
    [MobileHomeSerialNumberField.fieldName]:
      MobileHomeSerialNumberField.validator,
    [MobileHomeHitchLengthField.fieldName]:
      MobileHomeHitchLengthField.validator,
    [MobileHomeEaveWidthField.fieldName]: MobileHomeEaveWidthField.validator,
    [MobileHomeBoxWidthField.fieldName]: MobileHomeBoxWidthField.validator,
    [MobileHomeBoxLengthField.fieldName]: MobileHomeBoxLengthField.validator,
    [MobileHomeRoadsideEavesLengthField.fieldName]:
      MobileHomeRoadsideEavesLengthField.validator,
    [MobileHomeCurbsideEavesLengthField.fieldName]:
      MobileHomeCurbsideEavesLengthField.validator,
    [MobileHomeHudNumberField.fieldName]: MobileHomeHudNumberField.validator,
    [TripOriginalOriginField.fieldName]: TripOriginalOriginField.validator,
    [TripFinalDestinationField.fieldName]: TripFinalDestinationField.validator,
    [TripOriginField.fieldName]: TripOriginField.validator,
    [TripDestinationField.fieldName]: TripDestinationField.validator,
    [TripBaseRegisteredWeightField.fieldName]:
      TripBaseRegisteredWeightField.validator,
    [TripRouteField.fieldName]: TripRouteField.validator,
    [TripMileageField.fieldName]: TripMileageField.validator,
    [TripIncludesReturnTripField.fieldName]:
      TripIncludesReturnTripField.validator,
    [TripReturnDestinationField.fieldName]:
      TripReturnDestinationField.validator,
    [TripReturnRouteField.fieldName]: TripReturnRouteField.validator,
    [TripReturnMileageField.fieldName]: TripReturnMileageField.validator,
    [TripEffectiveDateField.fieldName]: TripEffectiveDateField.validator,
    [AxleSpacingField.fieldName]: AxleSpacingField.validator,
    [AxleWeightField.fieldName]: AxleWeightField.validator,
    [AxleWidthField.fieldName]: AxleWidthField.validator,
    [AxleCapacityField.fieldName]: AxleCapacityField.validator,
    [TireCountField.fieldName]: TireCountField.validator,
    [TireRatingField.fieldName]: TireRatingField.validator,
    [TireSizeField.fieldName]: TireSizeField.validator,
    [SuspensionField.fieldName]: SuspensionField.validator,
    [IsSteeringAxleField.fieldName]: IsSteeringAxleField.validator,
    [AxleGroupField.fieldName]: AxleGroupField.validator,
    [AxleTypeField.fieldName]: AxleTypeField.validator,
    [CaNSCField.fieldName]: CaNSCField.validator,
    [AbMVIDNumberField.fieldName]: AbMVIDNumberField.validator,
    [BcCustomerNumberField.fieldName]: BcCustomerNumberField.validator,
    [BcFINNumberField.fieldName]: BcFINNumberField.validator,
    [QcNEQNumberField.fieldName]: QcNEQNumberField.validator,
    [QcNIRNumberField.fieldName]: QcNIRNumberField.validator,
    [OnCVORNumberField.fieldName]: OnCVORNumberField.validator,
    [OnPRIOAccountNumberField.fieldName]: OnPRIOAccountNumberField.validator,
    [NLMasterNumberField.fieldName]: NLMasterNumberField.validator,
    [UsICCField.fieldName]: UsICCField.validator,
    [UsIFTAField.fieldName]: UsIFTAField.validator,
    [UsIRPNumberField.fieldName]: UsIRPNumberField.validator,
    [UsDotNumberField.fieldName]: UsDotNumberField.validator,
    [FederalIDNumberField.fieldName]: FederalIDNumberField.validator,
    [LaNumberField.fieldName]: LaNumberField.validator,
    [KentuckyNumberField.fieldName]: KentuckyNumberField.validator,
    [MontanaNumberField.fieldName]: MontanaNumberField.validator,
    [OregonNumberField.fieldName]: OregonNumberField.validator,
    [TennesseeNumberField.fieldName]: TexasNumberField.validator,
    [TexasNumberField.fieldName]: TexasNumberField.validator,
    [AccountNumbersBilingualField.fieldName]:
      AccountNumbersBilingualField.validator,
  })
  .required();

export type AddPermitTypeFormInputs = yup.InferType<
  typeof AddPermitTypeFormInputs
>;
